export const exportChartData = async (request, payload, chartType) => {
    try {
        const response = await request("POST", `/v1/survey/charts/${chartType}/file`,{ data: payload, responseType: "blob"  }, "survey_service");
         return response;
    
    } catch (error) {
        console.log(error)
    }

};